const getDay = (date) => { // получить номер дня недели, от 0 (пн) до 6 (вс)
  let day = date.getDay();
  if (day === 0) day = 7; // сделать воскресенье (0) последним днем
  return day - 1;
}

export default getDay;
